module.exports = __webpack_public_path__ + "static/media/pt-sans-pro_extra-bold.248c9ab1.ttf";